const BULK_CATEGORIES = new Set([
  'Fencing',
  'Nutrition',
  'Agriculture chemical',
  'Horticulture chemical',
])

export const isBulkQuotable = (category: string) => {
  return BULK_CATEGORIES.has(category)
}
